import { Site } from '../../index.js';
import hirer from './maps/hirer.js';
import seekjobs from './maps/seekjobs.js';
import seekpass from './maps/seekpass.js';
export default (function (siteName, location) {
    switch (siteName) {
        case Site.SEEKJOBS:
        case 'seekAnz-candidate':
            return seekjobs(location);
        case Site.HIRER:
        case 'seekAnz-hirer':
            return hirer(location);
        case Site.SEEKPASS:
            return seekpass(location);
        default:
            throw new Error("Configuration not found for site: ".concat(String(siteName)));
    }
});
//# sourceMappingURL=getConfig.js.map